
<div class="header-c" *ngIf="reqst===2">
    Evolución de Precios - Estación <strong style="font-weight: 600;">{{stationName}}</strong>
</div>
<div class="flexi">
    <div class="flex-item" *ngIf="activeBuf === 0 && reqst ===2">
        <div class="graphic">
          <highcharts-chart
            [Highcharts]="Highcharts"
            [options]="chartOptions0"
            [oneToOne]="true"
            [(update)]="updateFlag0"
            style="min-width:80vw;width:100%;height:650px;display:block;">
          </highcharts-chart>
        </div>
      </div>

      <div class="flex-item" *ngIf="activeBuf === 1 && reqst ===2">
        <div class="graphic">
          <highcharts-chart
            [Highcharts]="Highcharts"
            [options]="chartOptions1"
            [oneToOne]="true"
            [(update)]="updateFlag1"
            style="min-width:80vw;width:100%;height:650px;display:block;">
          </highcharts-chart>
        </div>
      </div>
    <div *ngIf="reqst===1" class="text-center loader-container">
      <div class="spinner-grow align-middle text-primary" role="status">
      <span class="sr-only">Loading...</span>
      </div>
  </div>
</div>